import { render, staticRenderFns } from "./widgetControl.vue?vue&type=template&id=46028489&"
import script from "./widgetControl.vue?vue&type=script&lang=ts&"
export * from "./widgetControl.vue?vue&type=script&lang=ts&"
import style0 from "./widgetControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46028489', component.options)
    } else {
      api.reload('46028489', component.options)
    }
    module.hot.accept("./widgetControl.vue?vue&type=template&id=46028489&", function () {
      api.rerender('46028489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/widgetControl.vue"
export default component.exports